module.exports = __webpack_public_path__ + "static/media/navIcon.8d19b261.svg";